import React, { useState } from 'react';
import { Button, FormControlLabel, FormGroup, Switch } from '@mui/material';
import TextField from '@mui/material/TextField';
import Modal from 'components/common/Modal';
import { TwilioAvailablePhoneNumbersFilter } from 'types/twilio/twilioAvailablePhoneNumber';
import { TwilioAvailablePhoneNumbers } from '../availablePhoneNumbers/TwilioAvailablePhoneNumbers';
import styles from './TwilioCampaignPhoneNumber.module.scss';

interface TwilioCampaignPhoneNumberProps {
  messagingServiceId: string | null | undefined;
  campaignId: string | null | undefined;
  businessId: number;
}

export const TwilioCampaignPhoneNumber = ({
  messagingServiceId,
  businessId,
  campaignId,
}: TwilioCampaignPhoneNumberProps) => {
  const [isAvailablePhoneNumbersModalOpen, setIsAvailablePhoneNumbersModalOpen] =
    useState<boolean>(false);
  const [availablePhoneNumbersOptions, setAvailablePhoneNumbersOptions] =
    useState<TwilioAvailablePhoneNumbersFilter>({
      areaCode: '',
      mmsEnabled: true,
      smsEnabled: true,
      voiceEnabled: true,
    });

  const handleInputChange =
    (field: keyof TwilioAvailablePhoneNumbersFilter) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setAvailablePhoneNumbersOptions((prev) => ({
        ...prev,
        [field]: event.target.value,
      }));
    };

  const handleSwitcherChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAvailablePhoneNumbersOptions((prev) => ({
      ...prev,
      [event.target.name]: event.target.checked,
    }));
  };

  const closeAvailablePhoneNumbersModal = () => setIsAvailablePhoneNumbersModalOpen(false);

  if (!campaignId || !messagingServiceId) {
    return <p className="mt-2 ml-3">Campaign have not been created yet</p>;
  }

  return (
    <div>
      <div className={styles.filter}>
        <TextField
          type="text"
          multiline
          variant="outlined"
          color="secondary"
          label="Area Code"
          onChange={handleInputChange('areaCode')}
          value={availablePhoneNumbersOptions.areaCode}
          fullWidth
        />

        <FormGroup style={{ marginLeft: '10px' }}>
          <FormControlLabel
            control={
              <Switch
                onChange={handleSwitcherChange}
                checked={availablePhoneNumbersOptions.smsEnabled}
                name="smsEnabled"
              />
            }
            label="SMS enabled"
          />

          <FormControlLabel
            control={
              <Switch
                onChange={handleSwitcherChange}
                checked={availablePhoneNumbersOptions.mmsEnabled}
                name="mmsEnabled"
              />
            }
            label="MMS enabled"
          />

          <FormControlLabel
            control={
              <Switch
                onChange={handleSwitcherChange}
                checked={availablePhoneNumbersOptions.voiceEnabled}
                name="voiceEnabled"
              />
            }
            label="Voice enabled"
          />
        </FormGroup>

        <Button
          style={{ marginLeft: '10px' }}
          variant="outlined"
          onClick={() => setIsAvailablePhoneNumbersModalOpen(true)}
        >
          Open available phone numbers
        </Button>
      </div>

      {!!isAvailablePhoneNumbersModalOpen && (
        <Modal onClose={closeAvailablePhoneNumbersModal} modalHeight={'auto'}>
          <TwilioAvailablePhoneNumbers
            businessId={businessId}
            filter={availablePhoneNumbersOptions}
            messagingServiceId={messagingServiceId}
            onPurchase={closeAvailablePhoneNumbersModal}
          />
        </Modal>
      )}
    </div>
  );
};
